import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const SuccessionNumberOfBuyers = ({ query, updateCfaQuery }) => {
  const intl = useIntl();
  const validate = () => {
    const valid = query.numberOfBuyers >= 1 && query.numberOfBuyers <= 2;
    if (query.valid !== valid) {
      updateCfaQuery({ ...query, valid });
    }
  };

  useEffect(() => {
    validate();
  }, [query.numberOfBuyers]);

  return (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{intl.formatMessage({ id: 'succession.cash_flow_analysis.number_of_buyers.heading' })}</h2>
      <p className="text-gray-600 mb-8">{intl.formatMessage({ id: 'succession.cash_flow_analysis.number_of_buyers.subheading' })}</p>
      
      <div className="space-y-4">
        <label className="flex items-center p-4 border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50">
          <input
            type="radio"
            value="1"
            checked={query.numberOfBuyers === 1}
            onChange={() => updateCfaQuery({ ...query, numberOfBuyers: 1 })}
            className="mr-3 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-gray-900">{intl.formatMessage({ id: 'succession.cash_flow_analysis.number_of_buyers.one_buyer' })}</span>
        </label>
        
        <label className="flex items-center p-4 border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50">
          <input
            type="radio"
            value="2"
            checked={query.numberOfBuyers === 2}
            onChange={() => updateCfaQuery({ ...query, numberOfBuyers: 2 })}
            className="mr-3 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-gray-900">{intl.formatMessage({ id: 'succession.cash_flow_analysis.number_of_buyers.two_buyers' })}</span>
        </label>
      </div>
    </div>
  );
};

export default SuccessionNumberOfBuyers; 